import React, { useState } from 'react';
import moment from 'moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import { Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import BreytaAtkvaediDialog from './BreytaAtkvaediDialog';


export default function BreytaAtkvaediTable(props) {
  const { data, setData, setSnackbarOpen } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [atkvaediDialogOpen, setAtkvaediDialogOpen] = useState(false);
  const [selectedAtkvaedi, setSelectedAtkvaedi] = useState({});

  const handleClick = (event, data) => {
    setSelectedAtkvaedi(data);
    setAtkvaediDialogOpen(true);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (data.length === 0) return null;

  return (
    <div>
      <Card>
        <CardHeader title={`Skráð atkvæði fyrir ${data[0].atkvaedi.nafn}`} />
        <Divider />
        <CardContent>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Kennitala</TableCell>
                <TableCell>Atkvæði</TableCell>
                <TableCell>Tímastimpill</TableCell>
                <TableCell>Kosning</TableCell>
                <TableCell>Gilt</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((d) => (
                  <TableRow
                    key={d.atkvaedi.id}
                    hover
                    onClick={(event) => handleClick(event, d)}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell>
                      <IconButton size="small">
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>{d.atkvaedi.kennitala}</TableCell>
                    <TableCell>{d.atkvaedi.atkvaediTegund.lysing}</TableCell>
                    <TableCell>
                      {moment(d.atkvaedi.dagsetning).format("DD.MM.YYYY HH:mm")}
                    </TableCell>
                    <TableCell>{d.kosning.lysing}</TableCell>
                    <TableCell>{!d.atkvaedi.ogilt ? 'Já' : 'Nei'}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </CardContent>
      </Card>

      {atkvaediDialogOpen && (
        <BreytaAtkvaediDialog
          atkvaediDialogOpen={atkvaediDialogOpen}
          setAtkvaediDialogOpen={setAtkvaediDialogOpen}
          selectedAtkvaedi={selectedAtkvaedi}
          setData={setData}
          setSnackbarOpen={setSnackbarOpen}
        />
      )}
    </div>
  );
}